import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  Phases_getInstance1ydmp5ct4mzr8 as Phases_getInstance_0,
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
} from '../statement/HttpResponsePipeline.mjs';
import {
  platformResponseDefaultTransformers258gm9ywvn5cc as platformResponseDefaultTransformers,
  platformRequestDefaultTransformv8a3p2llr8mo as platformRequestDefaultTransform,
} from './DefaultTransform.web.mjs';
import {
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Application_getInstance2wn6cl3kv21f0 as Application_getInstance,
  Text_getInstancereo9eglzqyxz as Text_getInstance,
  Companion_getInstance1co6rysm0hsdc as Companion_getInstance,
  MultiPart_getInstance1qrv90sa9uvz5 as MultiPart_getInstance,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toLongkk4waq8msp1k as toLong,
  toInt2q8uldh7sc951 as toInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contentType2zzm38yxo3syt as contentType,
  contentLength2suzxu1lzutku as contentLength,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  canceldn4b3cdqcfny as cancel,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isByteArray4nnzfn1x4o3w as isByteArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  copyTo2si6ixg3c5rjz as copyTo,
  toByteArray39hw81iegcnuw as toByteArray,
  readRemaining1u8soafhjma7y as readRemaining,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  cancel2ztysw4v4hav6 as cancel_0,
  cancel36mj9lv3a0whl as cancel_1,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  WriterScope3b0bo1enaee6b as WriterScope,
  writer1eia5its2a1fh as writer,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from '../../../../../ktor-ktor-http-cio/io/ktor/http/cio/CIOMultipartDataBase.mjs';
import { MultiPartData57syw40llxls as MultiPartData } from '../../../../../ktor-ktor-http/io/ktor/http/content/Multipart.mjs';
import { HttpStatusCode3o1wkms10pg4k as HttpStatusCode } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  Key_instance2rlngjw9v1qsd as Key_instance,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from '../call/utils.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { Source1shr0ps16u4p4 as Source } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Source.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER;
}
var LOGGER;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().c5s_1;
  _this__u8e3s4.o5l_1.a4x(tmp, defaultTransformers$slambda_0());
  var tmp_0 = Phases_getInstance_0().z5m_1;
  _this__u8e3s4.p5l_1.a4x(tmp_0, defaultTransformers$slambda_2(_this__u8e3s4));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
var defaultTransformers$2$content$1Class;
function defaultTransformers$2$content$1() {
  if (defaultTransformers$2$content$1Class === VOID) {
    class $ extends ByteArrayContent() {
      constructor($contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.o5u_1 = $body;
        super($box);
        var tmp = this;
        tmp.m5u_1 = $contentType == null ? Application_getInstance().g4z_1 : $contentType;
        this.n5u_1 = fromInt($body.length);
      }
      p4b() {
        return this.m5u_1;
      }
      q4b() {
        return this.n5u_1;
      }
      q5b() {
        return this.o5u_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$2$content$1Class = $;
  }
  return defaultTransformers$2$content$1Class;
}
var defaultTransformers$2$content$2Class;
function defaultTransformers$2$content$2() {
  if (defaultTransformers$2$content$2Class === VOID) {
    class $ extends ReadChannelContent() {
      constructor($this_intercept, $contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.s5u_1 = $body;
        super($box);
        var tmp = this;
        var tmp0_safe_receiver = $this_intercept.w4w_1.m5n_1.d2p('Content-Length');
        tmp.q5u_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
        var tmp_0 = this;
        tmp_0.r5u_1 = $contentType == null ? Application_getInstance().g4z_1 : $contentType;
      }
      q4b() {
        return this.q5u_1;
      }
      p4b() {
        return this.r5u_1;
      }
      t5b() {
        return this.s5u_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$2$content$2Class = $;
  }
  return defaultTransformers$2$content$2Class;
}
var defaultTransformers$slambdaClass;
function defaultTransformers$slambda() {
  if (defaultTransformers$slambdaClass === VOID) {
    class $ {
      *h5l($this$intercept, body, $completion) {
        if ($this$intercept.w4w_1.m5n_1.d2p('Accept') == null) {
          $this$intercept.w4w_1.m5n_1.w4t('Accept', '*/*');
        }
        var contentType_0 = contentType($this$intercept.w4w_1);
        var tmp;
        if (typeof body === 'string') {
          tmp = new (TextContent())(body, contentType_0 == null ? Text_getInstance().j50_1 : contentType_0);
        } else {
          if (isByteArray(body)) {
            tmp = new (defaultTransformers$2$content$1())(contentType_0, body);
          } else {
            if (isInterface(body, ByteReadChannel())) {
              tmp = new (defaultTransformers$2$content$2())($this$intercept, contentType_0, body);
            } else {
              if (body instanceof OutgoingContent()) {
                tmp = body;
              } else {
                tmp = platformRequestDefaultTransform(contentType_0, $this$intercept.w4w_1, body);
              }
            }
          }
        }
        var content = tmp;
        if (!((content == null ? null : content.p4b()) == null)) {
          $this$intercept.w4w_1.m5n_1.a4u('Content-Type');
          get_LOGGER().a4y('Transformed with default transformers request body for ' + $this$intercept.w4w_1.k5n_1.toString() + ' from ' + toString(getKClassFromExpression(body)));
          yield* $this$intercept.y4v(content, $completion);
        }
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.h5l(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaultTransformers$slambdaClass = $;
  }
  return defaultTransformers$slambdaClass;
}
function defaultTransformers$slambda_0() {
  var i = new (defaultTransformers$slambda())();
  var l = ($this$intercept, body, $completion) => i.h5l($this$intercept, body, $completion);
  l.$arity = 2;
  return l;
}
var defaultTransformers$slambda$slambdaClass;
function defaultTransformers$slambda$slambda() {
  if (defaultTransformers$slambda$slambdaClass === VOID) {
    class $ {
      constructor($body, $response) {
        this.t5u_1 = $body;
        this.u5u_1 = $response;
      }
      *f5e($this$writer, $completion) {
        try {
          yield* copyTo(this.t5u_1, $this$writer.a4p_1, 9223372036854775807n, $completion);
        } catch ($p) {
          if ($p instanceof CancellationException()) {
            var cause = $p;
            cancel_1(this.u5u_1, cause);
            throw cause;
          } else {
            if ($p instanceof Error) {
              var cause_0 = $p;
              cancel_0(this.u5u_1, 'Receive failed', cause_0);
              throw cause_0;
            } else {
              throw $p;
            }
          }
        }
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.f5e(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    defaultTransformers$slambda$slambdaClass = $;
  }
  return defaultTransformers$slambda$slambdaClass;
}
function defaultTransformers$slambda$slambda_0($body, $response) {
  var i = new (defaultTransformers$slambda$slambda())($body, $response);
  var l = ($this$writer, $completion) => i.f5e($this$writer, $completion);
  l.$arity = 1;
  return l;
}
var defaultTransformers$slambdaClass_0;
function defaultTransformers$slambda_1() {
  if (defaultTransformers$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_defaultTransformers) {
        this.v5u_1 = $this_defaultTransformers;
      }
      *e5m($this$intercept, _destruct__k2r9zo, $completion) {
        var info = _destruct__k2r9zo.ze();
        var body = _destruct__k2r9zo.af();
        if (!isInterface(body, ByteReadChannel()))
          return Unit_instance;
        var response = $this$intercept.w4w_1.b5m();
        var tmp0_subject = info.o4x_1;
        var tmp;
        if (tmp0_subject.equals(getKClass(Unit()))) {
          cancel(body);
          tmp = yield* $this$intercept.y4v(new (HttpResponseContainer())(info, Unit_instance), $completion);
        } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().xf())) {
          tmp = yield* $this$intercept.y4v(new (HttpResponseContainer())(info, toInt(readText(yield* readRemaining(body, $completion)))), $completion);
        } else if (tmp0_subject.equals(getKClass(Source())) || tmp0_subject.equals(getKClass(Source()))) {
          tmp = yield* $this$intercept.y4v(new (HttpResponseContainer())(info, yield* readRemaining(body, $completion)), $completion);
        } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().gg())) {
          var bytes = yield* toByteArray(body, $completion);
          checkContentLength(contentLength($this$intercept.w4w_1.b5m()), fromInt(bytes.length), $this$intercept.w4w_1.b5o().j5o());
          tmp = yield* $this$intercept.y4v(new (HttpResponseContainer())(info, bytes), $completion);
        } else if (tmp0_subject.equals(getKClass(ByteReadChannel()))) {
          var responseJobHolder = Job(response.gw().bd(Key_instance));
          // Inline function 'kotlin.also' call
          var this_0 = writer($this$intercept, this.v5u_1.n5l_1, VOID, defaultTransformers$slambda$slambda_0(body, response));
          invokeOnCompletion(this_0, (it) => {
            responseJobHolder.y12();
            return Unit_instance;
          });
          var channel = this_0.y4o_1;
          tmp = yield* $this$intercept.y4v(new (HttpResponseContainer())(info, channel), $completion);
        } else if (tmp0_subject.equals(getKClass(HttpStatusCode()))) {
          cancel(body);
          tmp = yield* $this$intercept.y4v(new (HttpResponseContainer())(info, response.r5o()), $completion);
        } else if (tmp0_subject.equals(getKClass(MultiPartData()))) {
          var tmp0 = $this$intercept.w4w_1.b5m().v55().d2p('Content-Type');
          var tmp$ret$2;
          $l$block: {
            // Inline function 'kotlin.checkNotNull' call
            if (tmp0 == null) {
              var message = 'No content type provided for multipart';
              throw IllegalStateException().o(toString(message));
            } else {
              tmp$ret$2 = tmp0;
              break $l$block;
            }
          }
          var rawContentType = tmp$ret$2;
          var contentType = Companion_getInstance().ut(rawContentType);
          // Inline function 'kotlin.check' call
          if (!contentType.w50(MultiPart_getInstance().d50_1)) {
            var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
            throw IllegalStateException().o(toString(message_0));
          }
          var tmp1_safe_receiver = $this$intercept.w4w_1.b5m().v55().d2p('Content-Length');
          var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
          var body_0 = new (CIOMultipartDataBase())($this$intercept.gw(), body, rawContentType, contentLength_0);
          var parsedResponse = new (HttpResponseContainer())(info, body_0);
          tmp = yield* $this$intercept.y4v(parsedResponse, $completion);
        } else {
          tmp = null;
        }
        var result = tmp;
        if (!(result == null)) {
          get_LOGGER().a4y('Transformed with default transformers response body ' + ('for ' + $this$intercept.w4w_1.b5o().k5o().toString() + ' to ' + toString(info.o4x_1)));
        }
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.e5m(tmp, p2 instanceof HttpResponseContainer() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaultTransformers$slambdaClass_0 = $;
  }
  return defaultTransformers$slambdaClass_0;
}
function defaultTransformers$slambda_2($this_defaultTransformers) {
  var i = new (defaultTransformers$slambda_1())($this_defaultTransformers);
  var l = ($this$intercept, _destruct__k2r9zo, $completion) => i.e5m($this$intercept, _destruct__k2r9zo, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
//region block: exports
export {
  defaultTransformers as defaultTransformers2r9wd7ftt31zw,
};
//endregion

//# sourceMappingURL=DefaultTransform.mjs.map
